import { gql } from '@apollo/client'

export const GET_VOOH_BRANDS_NETWORK = gql`
  query voohBrandsNetworks($term: String) {
    voohBrandsNetworks(term: $term) {
      id
      name
      fullName
      type
    }
  }
`
